export default "/assets/images/smoky-gray-sm.11370a72f5debcf2.jpg";